import React from 'react';
import { Award, Clock3, HeartHandshake, Sparkles, Target } from 'lucide-react';

const reasons = [
  {
    icon: Target,
    title: 'Results-Oriented',
    description: 'Every session is built toward a tangible shift you can actually feel and name.',
  },
  {
    icon: HeartHandshake,
    title: 'Private 1 on 1 Help',
    description: 'Customized to you. Book a single session or a full 1 on 1 program with a practitioner who meets you exactly where you are, on your schedule, over Zoom.',
  },
  {
    icon: Award,
    title: 'Elite Practitioners',
    description: 'Only the most advanced, powerful guides make it onto our platform, verified and reviewed before they ever list a session.',
  },
  {
    icon: Clock3,
    title: 'Convenient Booking',
    description: 'Schedule online in minutes. All sessions are done over Zoom.',
  },
  {
    icon: Sparkles,
    title: 'Experiences and Membership',
    description: 'Looking for a group setting? We also host live and always-available Experiences and a variety of themed Memberships, each led by a different practitioner.',
  },
];

const WhyChooseUs = () => (
  <section className="bg-[#f7f1ff] py-20 text-purple-950 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto mb-14 max-w-3xl text-center">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-purple-600">
          Why choose us
        </p>
        <h2 className="mb-6 font-title text-4xl font-bold text-purple-900 sm:text-5xl">
          Real power. Real practitioners. Real results.
        </h2>
        <p className="text-lg leading-8 text-purple-800/75">
          Whatever you&apos;re moving through, a life transition, an emotional rough patch, or a quiet pull toward something more, there&apos;s a real path forward here.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-5">
        {reasons.map(({ icon: Icon, title, description }) => (
          <article
            key={title}
            className="rounded-2xl border border-purple-200/80 bg-white/75 p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-yellow-400/70 hover:shadow-xl"
          >
            <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-full bg-purple-900 text-yellow-300">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mb-3 font-subtitle text-lg font-bold text-purple-900">{title}</h3>
            <p className="text-sm leading-6 text-purple-800/75">{description}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseUs;